import { PUBLIC_STREAM_CONFIG } from '@gozoki/api-types';
import { removeTrailingSlash } from '@gozoki/tools';
import { gozokiApi } from '../gozokiApi';

export const fetchAiVideoIds = async (storeId: string): Promise<string[]> => {
    const camConfig = PUBLIC_STREAM_CONFIG.find(
        (config) => config.id === Number.parseInt(storeId, 10)
    );
    if (!camConfig) {
        return [];
    }
    const { cameraIds } = camConfig;
    return cameraIds.map((cameraId) => cameraId.toString());
};

export const generateStreamUrl = (
    storeId?: string | null,
    videoId?: string | null
): string | undefined => {
    const baseUrl = gozokiApi.defaults.baseURL;
    if (!storeId || !videoId || !baseUrl) {
        return undefined;
    }
    const returnUrl = `${removeTrailingSlash(
        baseUrl
    )}/stream-proxy/full/${storeId}/${videoId}/video.mjpeg`;
    return returnUrl;
};

export const generatePreviewStreamUrl = async (
    storeId?: string | null,
    videoId?: string | null
) => {
    const baseUrl = gozokiApi.defaults.baseURL;
    if (!storeId || !videoId || !baseUrl) {
        return null;
    }
    const returnUrl = `${removeTrailingSlash(
        baseUrl
    )}/stream-proxy/preview/${storeId}/${videoId}/video.mjpeg`;
    return returnUrl;
};
